/** @format */

import React, { useState, useEffect } from "react";
import LabelInput from "../../../shared/components/labelInput";
import { useFormContext } from "react-hook-form";
import { fetchVehicleClaim } from "../../../shared/services/simpleListItemsService";
import TqClaimMapper from "../mappers/tqClaimMapper";
import NewDatePicker from "../../../shared/components/newDatePicker";
import RadioGroup from "../../../shared/components/RadioGroup";
import FieldStack from "../../../shared/components/FieldStack";
import ModalWrapper from "../../../shared/components/ModalWrapper";

const TqClaimModal = ({
  onClaimSaved,
  onSaveClaim,
  isModalOpen,
  setIsModalOpen,
}) => {
  const {
    register,
    formState: { errors, isValid },
    watch,
    setValue,
    control,
    handleSubmit,
    trigger,
    reset,
  } = useFormContext();

  const [vClaim, setVClaim] = useState([]);

  const convertArrayFormat = (array) => {
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  };

  const onSubmit = (data) => {
    const index = watch("claimIndex");

    const claimData = {
      claimType: data.claimType,
      claimCost: data.claimCost,
      WhosFault: data.WhosFault,
      Injured: data.Injured,
      AddClaim_Date: data.AddClaim_Date,
      index: index, // Pass the index to the model
    };

    if (onSaveClaim) {
      onSaveClaim(claimData);
    } else {
      TqClaimMapper.set(claimData);
      onClaimSaved?.();
    }
    setIsModalOpen(false);
    reset();
  };

  const handleCloseClaimModel = () => {
    setIsModalOpen(false);
    reset();
  };

  useEffect(() => {
    fetchVehicleClaim().then((statuses) => setVClaim(statuses));
  }, []);

  return (
    <>
      {isModalOpen && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalWrapper
            heading={watch("claimIndex") !== null && watch("claimIndex") !== undefined ? "Edit Claim" : "Add a Claim"}
            size="large"
            buttonText="Save Details"
            buttonVariant={isValid ? "main" : "disabled"}
            onClose={handleCloseClaimModel}
            buttonType="submit"
          >
            <FieldStack className="tw-text-sm">
              <LabelInput
                id="claimType"
                label="What type of claim occured?"
                type="select"
                options={convertArrayFormat(vClaim)}
                control={control}
                placeholder="Select Claim"
                register={register("claimType", { required: true })}
                errors={errors.claimType}
                watch={watch("claimType")}
                trigger={trigger}
              />

              <NewDatePicker
                name="AddClaim_Date"
                label="What date did the incident occur?"
                errors={errors.AddClaim_Date}
                setValue={setValue}
                trigger={trigger}
                control={control}
                rules={{
                  required: "Date is required",
                }}
                watch={watch}
                maxDate={new Date()}
              />
              <LabelInput
                id="claimCost"
                label="What is the current cost of the claim?"
                type="number"
                prefix="£"
                placeholder="e.g. 7,000"
                register={register("claimCost", {
                  required: "Required",
                })}
                errors={errors.claimCost}
                watch={watch("claimCost")}
                trigger={trigger}
                pattern="[0-9]*"
              />
              <RadioGroup
                name="Injured"
                mainLabel="Was anyone injured in the incident?"
                register={register}
                trigger={trigger}
                errors={errors.Injured}
              />
              <RadioGroup
                name="WhosFault"
                mainLabel="Were you at fault?"
                secondaryLabel=" A fault claim is where your insurance company paid
                              out for any part of the claim. A non-fault claim
                              is where all costs are recovered from a third
                              party."
                register={register}
                trigger={trigger}
                errors={errors.WhosFault}
              />
            </FieldStack>
          </ModalWrapper>
        </form>
      )}
    </>
  );
};

export default TqClaimModal;
